import { useState } from "react";
import { resolveApiAssetUrl } from "@/shared/api/api-client";

function initialsFor(name: string): string {
  const initials = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0])
    .join("")
    .toLocaleUpperCase("pt-BR");
  return initials || "U";
}

export function ProfileAvatar({ name, avatarUrl }: { name: string; avatarUrl?: string | null }) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const resolvedUrl = resolveApiAssetUrl(avatarUrl);

  if (resolvedUrl && failedUrl !== resolvedUrl) {
    return (
      <img
        src={resolvedUrl}
        alt=""
        width={400}
        height={400}
        decoding="async"
        onError={() => setFailedUrl(resolvedUrl)}
      />
    );
  }

  return <span className="avatar-fallback" aria-hidden="true">{initialsFor(name)}</span>;
}
